import { render } from "./StockView.vue?vue&type=template&id=1742f74b&ts=true"
import script from "./StockView.vue?vue&type=script&lang=ts"
export * from "./StockView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__